const colors = {
  articleBgBlack: "#151515",
  black: "#000000",
  blackTooltip: "rgba(0,0,0,0.8)",
  // white: "#ffffff",
  darkGrey: "#1e1e1e",
  lightgrey: "#A1A1A1",

  // for dot plot
  white: "#ffffff",
  transparent: "transparent",
  ageUnder35: "#FFDB80",
  ageMiddle: "transparent",
  ageOver65: "#996E00",
  here1Red: "#FF0000",
  here2LightBlue: "#00D6E3",
  here3Yellow: "#FF9900",
  highlight1: "#00FF00",
  highlight2: "#FA00FF",
  highlight3: "hotpink",
  redLine: "#FF0000",
  lightBlue: "#A4E9FF",

  // old dot plot
  M: "#ffffff",
  F: "#000000",
  brightGreen: "#00FF00",
  blue: "#0000FF",
  red: "#FF0000",
}

export default colors
